// extracted by mini-css-extract-plugin
export default {"wrapper":"P2-z","play":"Q2-z"};